import { AfterViewInit, Directive, inject, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DIALOG_CONTENT } from '../constant/dialog.constant';
import { DialogContent, DialogProviders } from '../type/dialog.type';
import { DeepPartial } from '@core/util';

@Directive()
export abstract class GenericDialogDirective implements AfterViewInit {
  protected readonly injector = inject(Injector);
  protected abstract readonly dialog: MatDialogRef<unknown>;
  protected abstract readonly config: DeepPartial<DialogContent> & DialogProviders & Record<string, unknown>;
  @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;

  ngAfterViewInit(): void {
    this.setupComponent();
  }

  private setupComponent(): void {
    const { providers, dialogContent, dialogComponent } = this.config;
    const component = dialogContent ? DIALOG_CONTENT[dialogContent] : dialogComponent;

    this.container.clear();

    if (!component) return;

    // Keep the existing injector hierarchy
    const childInjector = Injector.create({ providers: [...(providers || [])], parent: this.injector });
    const componentRef = this.container.createComponent(component, { injector: childInjector });

    componentRef.changeDetectorRef.detectChanges(); // Ensures data binding works
  }
}
